import script from "./ExpireOverdueResultModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ExpireOverdueResultModal.vue?vue&type=script&setup=true&lang=js"

import "./ExpireOverdueResultModal.vue?vue&type=style&index=0&id=6685d812&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6685d812"]])

export default __exports__